<template>
  <a-modal
    :visible="true"
    title="Position Edit"
    :maskClosable="false"
    @cancel="handleGoBack"
    @ok="handleSubmit"
    okText="Save"
    cancelText="Cancel"
  >
    <!-- 表单 -->
    <a-form :form="editForm" autocomplete="off">
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="Job Title"
        hasFeedback
      >
        <a-input
          placeholder="Job Title"
          v-decorator="[
            'name',
            {rules: [{ required: true, message: 'Please input Position Name.' }]}
          ]"
        ></a-input>
      </a-form-item>
      <!-- 隐藏域 -->
      <a-form-item v-show="false"><a-input v-decorator="['id']"/></a-form-item>
      <a-form-item v-show="false"><a-input v-decorator="['departmentId']"/></a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import PositionApi from '@/api/adm/api-position'

export default {
  name: 'DeptPositionEdit',
  components: {
  },
  props: {
    departmentId: {
      type: [String],
      required: true
    },
    record: {
      type: [String, Object],
      required: true
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 24 }
        }
      },
      editForm: this.$form.createForm(this),
      createFlag: false,
      // 所有部门列表
      allDeptList: null
    }
  },
  mounted () {
    this.initData(this.record)
  },
  methods: {
    async initData (data) {
      var formData = null
      var createFlag = true
      if (data === '') {
        createFlag = true
        // 新增
        formData = { 'id': null, 'name': null, 'departmentId': this.departmentId }
      } else {
        createFlag = false
        // 编辑
        formData = pick(data, ['id', 'name', 'departmentId'])
      }
      this.$nextTick(() => {
        this.editForm.setFieldsValue(formData)
        this.createFlag = createFlag
      })
    },
    handleGoBack () {
      this.$emit('cancel')
    },
    handleConfirm () {
      this.$emit('confirm')
    },
    handleSubmit (e) {
      e.preventDefault()
      // eslint-disable-next-line
      this.editForm.validateFields((err, fieldsValue) => {
        // 如果校验失败直接返回
        if (err) {
          return
        }
        var formData = this.editForm.getFieldsValue()
        // 添加
        if (!formData.id || formData.id === null) {
          PositionApi.add(formData).then(res => {
            if (!this.mixinProcessHasBizErrorNotification(res)) {
              this.mixinProcessSuccessNotification('Save successfully !')
              this.handleConfirm()
            }
          })
        }
        // 修改
        if (formData.id !== null) {
          PositionApi.update(formData.id, formData).then(res => {
            if (!this.mixinProcessHasBizErrorNotification(res)) {
              this.mixinProcessSuccessNotification('Update successfully !')
              this.handleConfirm()
            }
          })
        }
      })
    }
  }
}
</script>
